import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import './landingwelcome.scss';

const LandingWelcome = ({ payload }) => {
  const { landingwelcome } = payload;
  const { t } = useTranslation();

  //if (!landingwelcome) return null;

  return (
    <section className="landingwelcome">
      <div className="landingwelcome__container">
        <h1>{t(landingwelcome.title)}</h1>
        <div className="landingwelcome__container__important">
          <h2>{t(landingwelcome.subtitle)}</h2>
          <h6>{t(landingwelcome.description)}</h6>
          <div className="flex__class--rowCenter">
            <a className="button" href={landingwelcome.cta.href}>{t(landingwelcome.cta.label)}</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LandingWelcome;